var _a;
import { Ribbon_Health_Education_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Ribbon_Health_Education_Type.DentalSchool] = 'Dental School',
    _a[Ribbon_Health_Education_Type.Fellowship] = 'Fellowship',
    _a[Ribbon_Health_Education_Type.GraduateSchool] = 'Graduate School',
    _a[Ribbon_Health_Education_Type.Internship] = 'Internship',
    _a[Ribbon_Health_Education_Type.MedicalSchool] = 'Medical School',
    _a[Ribbon_Health_Education_Type.Other] = 'Other',
    _a[Ribbon_Health_Education_Type.Residency] = 'Residency',
    _a[Ribbon_Health_Education_Type.School] = 'School',
    _a[Ribbon_Health_Education_Type.UndergraduateSchool] = 'Undergraduate School',
    _a);
export var RibbonHealthEducationTypeEnum = {
    name: 'Ribbon_Health_Education_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
